import axios from "axios"
import * as env from "../constants/env"

/* Get Unread Count */
export const get = () => {
    const uri = `${env.startpoint}notification/get`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}


/* Notification List */
export const list = (page = 1) => {
    const uri = `${env.startpoint}notification/list?page=${page}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}


/* Read Every Notification */
export const read = () => {
    const uri = `${env.startpoint}notification/read`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, {}, headers).then((response) => response).catch((data) => data.response)
}
